import React from "react";


import background from '@cover/fuehlenstarten/background-1.svg';
import FuehlenStarten from "../components/cover/animations/fuehlenstarten";

export const meta = {
	category: "start",
	slug: "fuehlen",
	name: "fühlenstarten",
	id: "FuehlenStarten",
	title: "Anleitung für das Erleben mit allen Sinnen:",
	excerpt: {
		before: "Keine Hektik. Nehmen Sie sich Zeit. Keine Bewegung. Was hören Sie? Was sehen Sie?"
	},
	animation: FuehlenStarten,
	cover: {
		background: {
			lg: background,
			sm: background
		},
		alt: "Eine bunte Gedankenwelt zwischen Hellem und Dunklem, in der sich verschiedene Gegenstände und Formen befinden."
	}
}

const FuehlenstartenArticle = () => {
	return (
		<div>
			<ol className="articleList articleList--ordered">
				<li className="articleListItem">Keine Störung. Handy aus!</li>
				<li className="articleListItem">Keine Hektik. Nehmen Sie sich Zeit. Keine Bewegung. Was hören Sie? Was sehen Sie?</li>
				<li className="articleListItem">Keine Ablenkung. Schließen Sie Ihre Augen: Was fühlen Sie? Was riechen Sie?</li>
				<li className="articleListItem">Schlendern, rasten, wahrnehmen. Schweigen, lauschen, träumen.</li>
				<li className="articleListItem">Machen Sie eine Gehmeditation: Nehmen Sie jeden Ihrer Schritte ganz bewusst wahr: Gehen Sie einen Schritt, atmen Sie ein. Beim nächsten Schritt atmen Sie aus.</li>
			</ol>
		</div>
	)
};

export default FuehlenstartenArticle;